import { Box, Button, Card, Chip } from "@mui/material";
import BackIcon from "components/AppIcons/BackIcon";
import FaiButton from "MuiComponents/FaiButton";
import { useState } from "react";
import DynamicCardContent from "screens/OrdersAndReturns/Returns/components/DynamicCardContent";
import ContactMarchant from "./ContactMarchant";

export default function OrderDetails({ orderData, setOrderDetails }) {
	const [contact, setContact] = useState(false);

	// orderData is the flat table row; `.raw` holds the full SubOrderResponseDTO.
	const so = orderData?.raw || {};
	const items = so.items || [];
	const addr = so.address || {};

	const totalQty = items.reduce(
		(sum: number, it: any) => sum + (it?.quantity || 0),
		0
	);

	// variantAttributes is a list of {attribute, value} — pull size/colour out.
	const firstAttrs = items[0]?.variant?.variantAttributes || [];
	const attrValue = (name: string) =>
		firstAttrs.find(
			(a: any) => (a?.attribute || "").toLowerCase() === name
		)?.value || "-";

	const fmtDate = (d?: string) =>
		d ? new Date(d).toLocaleDateString() : "-";

	const addressLine =
		[
			addr.addressLine1,
			addr.addressLine2,
			addr.city,
			addr.state,
			addr.pinCode,
		]
			.filter(Boolean)
			.join(", ") || "-";

	const displayOrderId = so.razorpayOrderId || so.id || "-";

	const statusColor = (s: string) => {
		const v = (s || "").toLowerCase();
		if (v === "confirmed" || v === "delivered" || v === "fulfilled")
			return "success";
		if (v.includes("cancel") || v === "expired" || v.startsWith("rto"))
			return "error";
		return "warning";
	};

	const orderDetails = {
		title: "Order Details",
		data: [
			{ label: "Order ID", value: `#${displayOrderId}` },
			{ label: "Order Date", value: fmtDate(so.createdAt) },
			{ label: "Customer Name", value: addr.fullName || "-" },
			{
				label: "Products",
				value:
					items
						.map((it: any) => it?.product?.productName)
						.filter(Boolean)
						.join(", ") || "-",
			},
			{ label: "Quantity", value: `${totalQty} Pc` },
			{ label: "Size", value: attrValue("size") },
			{ label: "Color", value: attrValue("color") },
		],
	};

	const shippingData = {
		title: "Shipping Details",
		data: [
			{ label: "Address", value: addressLine },
			{ label: "Mobile", value: addr.mobile || "-" },
			{
				label: "Shipment ID",
				value: so.shiprocketShipmentId || "Not shipped yet",
			},
		],
	};

	const paymentData = {
		title: "Payment Method",
		data: [
			{ label: "Payment Mode", value: so.paymentMode || "-" },
			{ label: "Total Amount", value: `₹ ${so.totalPrice ?? 0}` },
			{ label: "COD Status", value: so.codPaymentStatus || "-" },
		],
	};

	return (
		<div className="space-y-2">
			<Card className="my-6 p-3 md:p-6 space-y-4">
				<Box className="flex justify-between">
					<Button
						startIcon={<BackIcon />}
						onClick={() => setOrderDetails()}
						className="!p-1 text-theme"
					>
						Back to Orders
					</Button>
				</Box>
				<Box>
					<div className="flex justify-between mb-4">
						<div>
							<span>Order Id #{displayOrderId}</span>
							<Chip
								label={so.status || "-"}
								color={statusColor(so.status)}
								sx={{ ml: 2 }}
							/>
						</div>
						<FaiButton color="primary" onClick={() => setContact(true)}>
							Contact Marchand
						</FaiButton>
						{contact && (
							<ContactMarchant onClose={() => setContact(false)} />
						)}
					</div>
					<Box
						className="rounded-lg p-4 grid grid-cols-1 md:grid-cols-3 gap-4"
						sx={{ backgroundColor: "#F9E9DA" }}
					>
						<DynamicCardContent {...orderDetails} />
						<DynamicCardContent {...shippingData} />
						<DynamicCardContent {...paymentData} />
					</Box>
				</Box>
			</Card>
		</div>
	);
}
